export const FOUND_VIN_SUBHEADER = {
  SINGLE_VIN: 'We found a VIN using the address you provided.',
  MULTIPLE_VINS: 'We found these vehicles based on the address you provided. Please select the correct one.',
};
